import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class ContatoService {

    getPorFiltro(parametros: any): Observable<HttpResponse<any>> {
        return this.http.get(
            environment.webApiSaguiControlUrl + '/api/contato/visualizarporfiltro', { params: parametros, observe: 'response' })
    }

    getContato(itemId: any): Observable<HttpResponse<any>> {
        return this.http.get(
            environment.webApiSaguiControlUrl + '/api/contato/visualiza/' + itemId, { observe: 'response' })
    }

    postContato(item: any): Observable<HttpResponse<any>> {
        return this.http.post(
            environment.webApiSaguiControlUrl + '/api/contato/inclui/', item, { observe: 'response' })
    };

    putContato(item: any, itemId: any): Observable<HttpResponse<any>> {
        return this.http.put(
            environment.webApiSaguiControlUrl + '/api/contato/atualiza/' + itemId, item, { observe: 'response' })
    };

    deleteContato(itemId: any): Observable<HttpResponse<any>> {
        return this.http.delete(
            environment.webApiSaguiControlUrl + '/api/contato/exclui/' + itemId, { observe: 'response' })
    }    

    constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

    }
}
